
export interface DNIDataMinor {
  BIRTHDATE: string;
  CITY_ADDRESS: string;
  DOC_NUMBER: string;
  EXPEDITION_DATE: string;
  EXPEDITOR: string;
  EXPIRY: string;
  SURNAME: string;
  FIRST_SURNAME: string;
  SECOND_SURNAME: string;
  ID_NUMBER: string;
  Image1cut: string;
  Image2cut: string;
  MODEL_ID: string;
  NAME: string;
  NATIONALITY: string;
  SEX: string;
  STATE_ADDRESS: string;
  STREET_ADDRESS: string;
  TEST_GLOBAL_AUTHENTICITY_RATIO: string;
  TEST_GLOBAL_AUTHENTICITY_VALUE: string;
  TYPE: string;
  postal_code: string;
  municipality_id: number | null;
  province_id: string;
  ImagePhoto: string;
}

export interface SetCheckInMinor {
  code: string;
  dni: DNIDataMinor;
  icar_verified: boolean;
  updated_fields: string[];
}

export class SetCheckInMinorBuilder {
  private checkInData: SetCheckInMinor;

  constructor(code: string) {
    this.checkInData = {
      code,
      icar_verified: true,
      updated_fields: [],
      dni: {
        BIRTHDATE: '',
        CITY_ADDRESS: '',
        DOC_NUMBER: '',
        EXPEDITION_DATE: '',
        EXPEDITOR: '',
        EXPIRY: '',
        SURNAME: '',
        FIRST_SURNAME: '',
        SECOND_SURNAME: '',
        ID_NUMBER: '',
        Image1cut: '',
        Image2cut: '',
        MODEL_ID: '',
        NAME: '',
        NATIONALITY: '',
        SEX: '',
        STATE_ADDRESS: '',
        STREET_ADDRESS: '',
        TEST_GLOBAL_AUTHENTICITY_RATIO: '',
        TEST_GLOBAL_AUTHENTICITY_VALUE: '',
        TYPE: '',
        postal_code: '',
        municipality_id: null,
        province_id: '',
        ImagePhoto: ''
      }
    };
  }

  withDNIData(dni: Partial<DNIDataMinor>): SetCheckInMinorBuilder {
    this.checkInData.dni = { ...this.checkInData.dni, ...dni };
    return this;
  }

  withPersonalInfo(name: string, surname: string, firstSurname: string, secondSurname: string, sex: string): SetCheckInMinorBuilder {
    this.checkInData.dni.NAME = name;
    this.checkInData.dni.SURNAME = surname;
    this.checkInData.dni.FIRST_SURNAME = firstSurname;
    this.checkInData.dni.SECOND_SURNAME = secondSurname;
    this.checkInData.dni.SEX = sex;
    return this;
  }

  withBirthDate(birthDate: string): SetCheckInMinorBuilder {
    this.checkInData.dni.BIRTHDATE = birthDate;
    return this;
  }

  withNationality(nationality: string, expeditor: string): SetCheckInMinorBuilder {
    this.checkInData.dni.NATIONALITY = nationality;
    this.checkInData.dni.EXPEDITOR = expeditor;
    return this;
  }

  withAddress(street: string, city: string, state: string, postalCode: string, provinceId: string, municipalityId: number | null): SetCheckInMinorBuilder {
    this.checkInData.dni.STREET_ADDRESS = street;
    this.checkInData.dni.CITY_ADDRESS = city;
    this.checkInData.dni.STATE_ADDRESS = state;
    this.checkInData.dni.postal_code = postalCode;
    this.checkInData.dni.province_id = provinceId;
    this.checkInData.dni.municipality_id = municipalityId;
    return this;
  }

  withDocument(idNumber: string, docNumber: string, type: string, expeditor: string): SetCheckInMinorBuilder {
    this.checkInData.dni.ID_NUMBER = idNumber;
    this.checkInData.dni.DOC_NUMBER = docNumber;
    this.checkInData.dni.TYPE = type;
    this.checkInData.dni.EXPEDITOR = expeditor;
    return this;
  }

  withDocumentDates(expeditionDate: string, expiry: string): SetCheckInMinorBuilder {
    this.checkInData.dni.EXPEDITION_DATE = expeditionDate;
    this.checkInData.dni.EXPIRY = expiry;
    return this;
  }

  withImages(image1: string, image2: string, photo: string): SetCheckInMinorBuilder {
    this.checkInData.dni.Image1cut = image1;
    this.checkInData.dni.Image2cut = image2;
    this.checkInData.dni.ImagePhoto = photo;
    return this;
  }

  withVerification(authenticity: string, authenticityRatio: string): SetCheckInMinorBuilder {
    this.checkInData.dni.TEST_GLOBAL_AUTHENTICITY_VALUE = authenticity;
    this.checkInData.dni.TEST_GLOBAL_AUTHENTICITY_RATIO = authenticityRatio;
    return this;
  }

  withModelId(modelId: string): SetCheckInMinorBuilder {
    this.checkInData.dni.MODEL_ID = modelId;
    return this;
  }

  withUpdatedFields(fields: string[]): SetCheckInMinorBuilder {
    this.checkInData.updated_fields = fields;
    return this;
  }

  disableIcarVerification(): SetCheckInMinorBuilder {
    this.checkInData.icar_verified = false;
    return this;
  }

  build(): SetCheckInMinor {
    return { ...this.checkInData };
  }

  // Método estático para crear desde datos mínimos requeridos
  static createBasic(code: string, name: string, surname: string, birthDate: string, sex: string): SetCheckInMinor {
    return new SetCheckInMinorBuilder(code)
      .withPersonalInfo(name, surname, '', '', sex)
      .withBirthDate(birthDate)
      .build();
  }
}
